import Component from '../vendor/Component'
import axios from 'axios'

export default class QuickBuy extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._popupElem = document.querySelector('[data-quick-buy-popup]')
    this._popupContentElem = this._popupElem.querySelector('[data-quick-buy-popup-content]')
    this._closeElems = this._popupElem.querySelectorAll('[data-quick-buy-popup-close]')
    this._popupInnerElem = this._popupElem.querySelector('[data-quick-buy-popup-inner]')
  }

  async mount() {
    if (this._elem) {
      this._elem.addEventListener('mouseover', async e => {
        await this._preloadQuickBuy(this._options.handle)
      })
      this._elem.addEventListener('click', async e => {
        e.preventDefault()
        this._elem.classList.add('btn--loading')
        await this._triggerQuickBuy()
        document.dispatchEvent(new Event("quickBuy", { bubbles: true }))
        this._elem.classList.remove('btn--loading')
      })
    }

    for (let elem of this._closeElems) {
      elem.addEventListener('click', e => {
        e.preventDefault()
        this._closePopup()
      })
    }

    this._popupElem.addEventListener('click', e => {
      if (e.target === this._popupElem) {
        this._closePopup()
      }
    })

    this._ctx.on('cart-item-added', async () => {
      this._closePopup()
    })
  }

  async _preloadQuickBuy(handle) {
    this._popupContentElem.innerHTML = ''
    let { data } = await axios.get(`/products/${handle}?view=quick-buy`)
    let parser = new DOMParser()
    let html = parser.parseFromString(data, 'text/html')
    let fetchedElem = html.querySelector('.shopify-section.product-page')

    this._popupContentElem.innerHTML = fetchedElem.outerHTML
    this._theme.mountComponents(this._popupContentElem)
  }

  async _triggerQuickBuy(handle) {
    this._popupElem.classList.add('shown')
    this._popupInnerElem.classList.add('loading')


    this._ctx.emit('ffc--scroll-lock-elem', null, this._popupContentElem)
    this._ctx.emit('ffc--lazy-load-update')

    this._popupInnerElem.classList.remove('loading')
  }

  _closePopup() {
    this._popupElem.classList.remove('shown')
    this._ctx.emit('ffc--clear-all-scroll-locks')
  }
}